import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import {
  isRegistrationPaymentPending,
  saveOperatorSession,
} from "../helpers/operatorSession";
import { setShowPreloader } from "../store/activePage";
import { setUserLoginStatus } from "../store/userStatus";

const HandleLogin = async (dispatch, navigate, data) => {
  dispatch(setShowPreloader(true)); // Show preloader before API call
  const loginres = await AxiosPostMethod("org/get-token", data, true);
  dispatch(setShowPreloader(false)); // Show preloader before API call
  console.log("loginres", loginres);
  if (loginres?.status === 403) {
    console.log("inside set token");
    localStorage.removeItem("dwt-tok");
    localStorage.setItem("dwt-tok-otp", loginres.data.data.access_token);
    navigate("/verify-mobile");
  } else if (loginres?.status === 423) {
    ErrorToast(
      loginres?.data?.message ||
        "Your organisation is pending admin approval. Please wait for activation."
    );
  } else if (loginres?.status === 200) {
    dispatch(setUserLoginStatus(true));
    saveOperatorSession(loginres.data.data);
    if (
      isRegistrationPaymentPending(
        loginres?.data?.data?.registration_payment_status,
      )
    ) {
      navigate("/registration-payment");
      ErrorToast("Registration payment is pending. Complete payment to continue.");
      return;
    }
    navigate("/dashboard/home");
    SuccessToast("Welcome Back!");
  } else {
    ErrorToast("Username or Password Incorrect");
  }
};

export default HandleLogin;
